import * as React from "react";
import { PbrInput } from "src/components/common/PbrInput/PbrInput";
import { useContext, SetStateAction, Dispatch, useState, useEffect } from "react";
import { PbrInputMask } from "src/components/common/PbrInput/PbrInputMask";
import { Row, Col, Select } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { ServiceContext } from "src/services/provider/Service.provider";
import { PbrCard } from "src/components/common/PbrCard/PbrCard";
import { IAddressOwner } from "src/services/interfaces/trade/tradeOwner/IAddressOwner";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { EstadosECidades } from "src/util/estados-cidades";
import { UploadDocumentButton } from 'src/components/Refatoracao/UploadDocument/UploadDocumentButton';
import { DocumentCategoryEnum, DocumentCategoryLabel } from 'src/components/Refatoracao/UploadDocument/DocumentCategoryEnum';
import { StorageTypeEnum } from 'src/components/Refatoracao/UploadDocument/StorageTypeEnum';

interface IEditTradeAddress extends FormComponentProps {
  trade: ITrade;
  setTrade: Dispatch<SetStateAction<ITrade>>;
  title: string;
}

export const EditTradeAddress: React.FC<IEditTradeAddress> = ({
  trade,
  setTrade,
  title,
  form
}) => {
  const { viaCepService } = useContext(ServiceContext);

  const [selectedState, setSelectedState] = useState([{ nome: "" }]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (trade.tradeOwner?.address?.state) {
      const newState = EstadosECidades.find(c => c.uf === trade.tradeOwner?.address?.state);
      setSelectedState(newState.cidades);
    }
  }, [trade.tradeOwner]);

  const handleAddressChange = (value: Partial<IAddressOwner>) => {
    setTrade(t => ({ ...t, tradeOwner: { ...t.tradeOwner, address: { ...t.tradeOwner.address, ...value } } }));
  };

  async function consultaCep(cep: string) {
    if (cep.length === 9) {
      const addressResponse = await viaCepService.getAddressByCep(cep);
      if (addressResponse) {
        clearEndereco();
        handleAddressChange({
          address: addressResponse.address,
          neighborhood: addressResponse.neighborhood,
          state: addressResponse.state,
          city: addressResponse.city,
          zipcode: addressResponse.zipCode
        });
        form.setFieldsValue({ endereco: addressResponse.address, estado: addressResponse.state, cidade: addressResponse.city, CEP: addressResponse.zipCode });
        document.getElementById("numero").focus();
      } else {
        document.getElementById("endereco").focus();
      }
    }
  }

  function clearEndereco() {
    setTrade({
      ...trade,
      tradeOwner: {
        ...trade.tradeOwner,
        address: {
          address: "",
          addressComplement: "",
          neighborhood: "",
          addressNumber: "",
          state: "",
          city: "",
          zipcode: ""
        }
      }
    });
  }

  return (
    <PbrCard className="default-tabs" title={title} bordered={false} style={{ width: "100%" }}>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={8} lg={8}>
          <PbrInputMask
            name="zipCode"
            formWrapper={form}
            title="CEP"
            mask="99999-999"
            placeholder="CEP"
            formItemProps={{ label: "CEP" }}
            value={trade.tradeOwner?.address?.zipcode}
            maskChar={null}
            onChange={e => {
              handleAddressChange({ zipcode: e.target.value });
              consultaCep(e.target.value);
            }}
            rules={[{ required: true, message: "Informe o CEP" }]}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={8}>
          <PbrSelect
            name="estado"
            size="large"
            formItemProps={{ label: "Estado" }}
            formWrapper={form}
            showSearch
            value={trade.tradeOwner?.address?.state}
            onChange={e => handleAddressChange({ state: e.toString(), city: "" })}
            placeholder="Estado"
            rules={[{ required: true, message: "Informe o estado" }]}
          >
            <Select.Option key={"none"} value="">
              Selecione o estado
            </Select.Option>
            {EstadosECidades.map((e, i) => (
              <Select.Option key={i.toString()} value={e.uf}>{`${e.nome}`}</Select.Option>
            ))}
          </PbrSelect>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8}>
          <PbrSelect
            name="cidade"
            size="large"
            formItemProps={{ label: "Cidade" }}
            formWrapper={form}
            showSearch
            value={trade.tradeOwner?.address?.city}
            onChange={e => handleAddressChange({ city: e.toString() })}
            placeholder="Cidade"
            rules={[{ required: true, message: "Informe a cidade" }]}
          >
            <Select.Option key={"none"} value="">
              Selecione a cidade
            </Select.Option>
            {selectedState.map((e, i) => (
              <Select.Option key={i.toString()} value={e.nome}>{`${e.nome}`}</Select.Option>
            ))}
          </PbrSelect>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={12} lg={12}>
          <PbrInput
            name="endereco"
            style={{ color: "black" }}
            formItemProps={{ label: "Endereço residencial" }}
            placeholder="Rua / Avenida"
            formWrapper={form}
            value={trade.tradeOwner?.address?.address}
            onChange={e => handleAddressChange({ address: e.target.value })}
            rules={[{ required: true, message: "Rua é obrigatório" }]}
          />
        </Col>
        <Col xs={24} sm={24} md={6} lg={6}>
          <PbrInput
            name="numero"
            value={trade.tradeOwner?.address?.addressNumber}
            style={{ color: "black" }}
            formItemProps={{ label: "Número" }}
            placeholder="Número"
            formWrapper={form}
            rules={[{ required: true, message: "Número é obrigatório" }]}
            onChange={e => handleAddressChange({ addressNumber: e.target.value })}
          />
        </Col>
        <Col xs={24} sm={24} md={6} lg={6}>
          <PbrInput
            name="addressComplement"
            value={trade.tradeOwner?.address?.addressComplement}
            style={{ color: "black" }}
            formItemProps={{ label: "Complemento" }}
            formWrapper={form}
            placeholder={"Ex: Fundos"}
            onChange={e => handleAddressChange({ addressComplement: e.target.value })}
            rules={[{ required: false, message: "" }]}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={24} md={8} lg={8}>
          <UploadDocumentButton
            trade={trade}
            setLoading={setLoading}
            isEnableAlways={!loading}
            title={DocumentCategoryLabel.get(DocumentCategoryEnum.PROOF_OF_RESIDENCE)}
            hoverTextDisabled="Documento já enviado"
            dontReloadTrade
            uploadCategory={DocumentCategoryEnum.PROOF_OF_RESIDENCE}
            storageType={StorageTypeEnum.S3}
          />
        </Col>
      </Row>
    </PbrCard>
  );
}


// WEBPACK FOOTER //
// ./src/components/common/TradeEdit/EditAddress/EditTradeAddress.tsx